import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import ReduxThunk from 'redux-thunk';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react';
import NotificationsSystem from 'reapop';
import theme from 'components/UI/Notification/theme';
import { CookieBanner } from '@palmabit/react-cookie-law';
import '../index.scss';

/**
 * Import components
 */

// import Authentication from './components/Authentication';
import Loader from 'components/Loading/Loader';
import createRootReducer from 'reducers';


/**
 * Define Redux middleware
 */

export const history = createBrowserHistory();
const middleware = [
    ReduxThunk,
    routerMiddleware(history)
];

/**
 * Activate a logger when on development environments
 */

if (process.env.NODE_ENV !== 'production') {
    middleware.push(require('redux-logger').createLogger());
}

/**
 * Create new Redux store
 */

export const store = createStore(
    createRootReducer(history),
    applyMiddleware(...middleware)
);

export const persistor = persistStore(store);

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <PersistGate persistor={persistor} loading={<Loader />}>
                    <ConnectedRouter history={history}>
                        <div styleName="app-wrapper">
                            {this.props.children}
                            <NotificationsSystem theme={theme}/>
                            <CookieBanner
                                message="Wij gebruiken cookies om onze website en onze service te optimaliseren."
                                styles={{
                                    dialog: {
                                        position: 'fixed',
                                        bottom: '0px',
                                        left: '0px',
                                        right: '0px',
                                        zIndex: '100000',
                                        backgroundColor: 'rgb(255, 255, 255)',
                                        padding: '25px',
                                    },
                                    container: {
                                        maxWidth: '650px',
                                        margin: '0 auto',
                                        position: 'relative',
                                    },
                                    optionLabel: {
                                        color: '#242c40',
                                        margin: '0 0 0 20px',
                                        fontSize: '10pt',
                                    },
                                    buttonWrapper: {
                                        position: 'absolute',
                                        right: '0px',
                                        bottom: '0px'
                                    },
                                    button: {
                                        margin: '15px 0 0 0',
                                        color: '#242c40',
                                        backgroundColor: '#fae800',
                                        borderColor: '#fae800',
                                        padding: '12px 0',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        border: '0px',
                                        width: '100px',
                                    }
                                }}
                                wholeDomain={true}
                                policyLink="https://www.planning-en-agenda.nl/privacyverklaring/"
                                privacyPolicyLinkText="Privacy- en cookiebeleid"
                                acceptButtonText='Accepteren'
                                showPreferencesOption={false}
                                showMarketingOption={false}
                                onAccept = {() => {}}
                                onAcceptStatistics = {() => {}}
                            />
                        </div>
                        
                    </ConnectedRouter>
                </PersistGate>
            </Provider>
        );
    }
}

export default App;